import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M9 6v12\"></path><circle cx=\"9\" cy=\"4\" r=\"2\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle><circle cx=\"15\" cy=\"8\" r=\"2\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle><circle cx=\"9\" cy=\"20\" r=\"2\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M9 18v-4a2 2 0 0 1 2-2h2a2 2 0 0 0 2-2\"></path>", 5)
  ]))]))
}
export default { render: render }